import { paths } from '@/shared/config/paths';
import type { TableColumn } from '@/shared/types';
import type { CourseWithCount, ContestSouvenirDto } from '@api/generated/model';

// 정렬
export const orderByOptions = [
	{ title: '최신 순', value: 'desc' },
	{ title: '오래된 순', value: 'asc' }
];

// 사용/미사용
export const usageStatusOptions = [
	{ title: '사용', value: 1 },
	{ title: '미사용', value: 0 }
];

// 메인페이지 게시 설정
export const usePublishPeriodOptions = [
	{ title: '메인 노출 사용', value: 1 },
	{ title: '메인 노출 사용하지 않음', value: 0 }
];

// 참가자 선정 방식
export const selectionMethodOptions = [
	{ title: '선착순', value: 'FCFS' },
	{ title: '추첨제(자동추천)', value: 'LOTTERY' }
];

// 코스 테이블 컬럼 정의
export const courseColumns: TableColumn<CourseWithCount>[] = [
	{
		key: 'name',
		header: '코스명'
	},
	{
		key: 'capacity',
		header: '모집명수',
		render: (row) => `• ${row.capacity.toLocaleString()}명`
	},
	{
		key: 'price',
		header: '가격',
		render: (row) => `• ${row.price.toLocaleString()}원`
	}
];

export const souvenirColumns: TableColumn<ContestSouvenirDto>[] = [
	{
		key: 'name',
		header: '옵션명'
	},
	{
		key: 'quantity',
		header: '수량',
		render: (row) => `• ${row.quantity.toLocaleString()}개`
	},
	{
		key: 'price',
		header: '수량',
		render: (row) => `• ${row.price.toLocaleString()}원`
	}
];

// 대회 상태
export const contestStatusOptions = [
	{ title: '전체', value: '' },
	{ title: '오픈대기중', value: 'SCHEDULED' },
	{ title: '사전예약중', value: 'RECRUITING' },
	{ title: '추가모집중', value: 'ADDITIONAL_RECRUITING' },
	{ title: '티켓품점', value: 'SOLD_OUT' },
	{ title: '대회준비중', value: 'PREPARING' },
	{ title: '대회진행중', value: 'IN_PROGRESS' },
	{ title: '종료', value: 'COMPLETED' },
	{ title: '취소', value: 'CANCELED' }
];

// 프로그램 상태
export const programStatusOptions = [
	{ title: '전체', value: '' },
	{ title: '오픈대기중', value: 'SCHEDULED' },
	{ title: '티켓품점', value: 'SOLD_OUT' },
	{ title: '프로그램 준비중', value: 'PREPARING' },
	{ title: '진행중', value: 'IN_PROGRESS' },
	{ title: '종료', value: 'COMPLETED' },
	{ title: '취소', value: 'CANCELED' }
];

// 예약 상태
export const reservationStatusOptions = [
	{ title: '전체', value: '' },
	{ title: '예약 신청', value: 'APPLIED' },
	{ title: '결제 대기', value: 'PAYMENT_PENDING' },
	{ title: '결제 완료', value: 'PAYMENT_CONFIRMED' },
	{ title: '취소', value: 'CANCELED' }
	// { title: '참가 완료', value: 'COMPLETED' },
];

// 상다 GNB 메뉴
export const headerMenu = [
	{ dataText: '대시보드', pathname: paths.dashboard.path },
	{ dataText: '메인섹션', pathname: paths.mainSection.topBanner.list.path },
	{ dataText: '회원', pathname: paths.user.list.path },
	{ dataText: '대회', pathname: paths.contest.list.path },
	{ dataText: '프로그램', pathname: paths.program.list.path },
	{ dataText: '운영', pathname: paths.operation.caption.list.path },
	{ dataText: '스토어', pathname: '/store/list' },
	{ dataText: '통계', pathname: '/stats' }
];

